import { render, staticRenderFns } from "./ArticleInfo.vue?vue&type=template&id=a503c34c&scoped=true"
import script from "./ArticleInfo.vue?vue&type=script&lang=ts"
export * from "./ArticleInfo.vue?vue&type=script&lang=ts"
import style0 from "./ArticleInfo.vue?vue&type=style&index=0&id=a503c34c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a503c34c",
  null
  
)

export default component.exports